import { useLocation } from 'react-router-dom';

/**
 * Returns the current app's `theme_id` for body class application.
 *
 * Maps the current route to one of the platform theme IDs seeded in
 * `backend/src/db/seed.py`:
 *   - 'nerdy-paradise' (launcher / root)
 *   - 'llm-chat'
 *   - 'smart-news'
 *   - 'surftime'
 *   - 'localtea'
 *   - 'trading-agent'
 *
 * Consumers apply the class as `body.theme-{theme_id}`.
 */
export type AppThemeId =
  | 'nerdy-paradise'
  | 'llm-chat'
  | 'smart-news'
  | 'surftime'
  | 'localtea'
  | 'trading-agent'
  | 'bitzbuggy';

// Match routes like /apps/{slug}/... (desktop) and /{slug}/... (PWA).
// Order matters — more specific matches first.
const ROUTE_TO_THEME: Array<[RegExp, AppThemeId]> = [
  [/^\/apps\/llm-chat(\/|$)/, 'llm-chat'],
  [/^\/apps\/smart-news(\/|$)/, 'smart-news'],
  [/^\/apps\/surftime(\/|$)/, 'surftime'],
  [/^\/apps\/localtea(\/|$)/, 'localtea'],
  [/^\/apps\/trading-agent(\/|$)/, 'trading-agent'],
  [/^\/apps\/bitzbuggy(\/|$)/, 'bitzbuggy'],
  [/^\/llm-chat(\/|$)/, 'llm-chat'],
  [/^\/smart-news(\/|$)/, 'smart-news'],
  [/^\/surftime(\/|$)/, 'surftime'],
  [/^\/localtea(\/|$)/, 'localtea'],
  [/^\/trading-agent(\/|$)/, 'trading-agent'],
  [/^\/bitzbuggy(\/|$)/, 'bitzbuggy'],
];

export function useCurrentApp(): AppThemeId {
  const { pathname } = useLocation();
  for (const [pattern, themeId] of ROUTE_TO_THEME) {
    if (pattern.test(pathname)) return themeId;
  }
  return 'nerdy-paradise';
}
